// extracted by mini-css-extract-plugin
export default {"select":"MergeDealersForm_select__j7Dxb","smallBtn":"MergeDealersForm_smallBtn__ft-Dy","btnText":"MergeDealersForm_btnText__Siio4","modal":"MergeDealersForm_modal__WEG3b"};